'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/remark-parse/lib/locate/escape.js
// module id = 355
// module chunks = 0 1 9 10